export const SOURCES = {
  Rob: 'ROB-Net',
  TecRMI: 'TecRMI',
  LKQ: 'LKQ',
  PartsPoint: 'PartsPoint',
  Custom: 'Invoer',
};
